<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/19fIcw3/tc-custom/9781504038324.jpg?1705552748660" alt="This image is the cover for the book Lawrence Sanders Thriller Collection Volume Two"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lawrence Sanders Thriller Collection Volume Two
      </h1>
      <p class="bookDescription body article font2">
        <b>Three gripping novels from the #1 <i>New York Times</i>–bestselling “master of suspense” and author of the Edward X. Delaney Series (<i>The</i><i> Washington Post</i>).</b><br/><br/> Whether the threat is technological, political, or up close and personal, the Edgar Award–winning author of the Commandment thrillers always keeps the tension running high. Included in this special volume are:<br/>  <br/><i>The Tomorrow File</i>: In the future, the government controls every aspect of its citizens’ lives, from their gender and their genes to where they work, what they eat, and how they love. Lawrence Sanders tells the story of what happens to utopia when people get fed up with pleasure, and stand up to fight for their right to live how they choose—and die for what they believe in.<br/>  <br/><i>The Passion of Molly T.</i>: Activism runs rampant on the college campus where young Molly Turner seeks vengeance after her radical feminist girlfriend is killed by homophobic bigots, drawing a fine line between justice and mayhem.<br/>  <br/><i>Capital Crimes</i>: His name is Brother Kristos, and to the president of the United States, he is a savior, a holy man who has been able to do something no doctor could manage: heal the president’s son. But as the president relies more and more on the mystic, the country slips toward chaos—and an explosive finale.<br/>  <br/> These three novels show the world on the brink of disaster. Whether set in the distant future or the here and now, the thrillers in this three-volume omnibus will prove impossible to put down.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lawrence Sanders
      </h2>
      
      <p class="authorDescription body article">Lawrence Sanders (1920&ndash;1998) was the <i>New York Times </i>bestselling author of more than forty mystery and suspense novels. <i>The Anderson Tapes, </i>completed when he was fifty years old, received an Edgar Award from the Mystery Writers of America for best first novel. His prodigious oeuvre encompasses the Edward X. Delaney, Archy McNally, and Timothy Cone series, along with his acclaimed Commandment books. Stand-alone novels include <i>Sullivan's Sting</i> and <i>Caper.</i> Sanders remains one of America&rsquo;s most popular novelists, with more than fifty million copies of his books in print.&#160;&#160; &#160; &#160;</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f6f1fc70